"use client"

import { capitalizeSpanish } from "#core/functions/string"
import { Box, Paper, Tab, Tabs } from "@mui/material"
import { toast } from "react-toastify"

const lista = [
	{
		id: 1,
		label: "Item One",
		content: "Content for Item One",
	},
]

export default function TabMaster({ listTabs = [], selectedTab, setSelectedTab }) {
	return (
		<main className="min-h-screen bg-background">
			<Paper sx={{ borderRadius: 2, overflow: "hidden", mb: 0, p: 0 }}>
				<TabsName {...{ listTabs, selectedTab, setSelectedTab }} />
				<TabsItem
					{...{
						listTabs,
						selectedTab,
					}}
				/>
			</Paper>
		</main>
	)
}

const TabsName = ({ listTabs, selectedTab, setSelectedTab }) => {
	return (
		<Tabs
			value={selectedTab}
			onChange={(e, newValue) => {
				setSelectedTab(newValue)
			}}
			variant="scrollable"
			scrollButtonsDisplay="auto"
			sx={{
				bgcolor: "#f5f5f5",
				"& .MuiTab-root": {
					fontWeight: 500,
					fontSize: "1rem",
					textTransform: "none",
					minHeight: 64,
				},
				"& .MuiTabs-indicator": {
					height: 4,
					// background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
				},
			}}
		>
			{listTabs.map((tab) => {
				const label = capitalizeSpanish(tab.label || tab.id)
				const idTab = tab.id || tab.label
				return (
					<Tab
						key={tab.id || tab.label}
						label={label}
						value={idTab}
						iconPosition="start"
					/>
				)
			})}
		</Tabs>
	)
}

const TabsItem = ({ listTabs, selectedTab }) => {
	return listTabs.map((tab) => {
		const idTab = tab.id || tab.label
		return (
			<TabPanel key={idTab} value={selectedTab} index={idTab}>
				{tab?.content}
			</TabPanel>
		)
	})
}

function TabPanel({ children, value, index, ...other }) {
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
		</div>
	)
}
